import { useEffect, useState } from "react";
import { createClient } from "../../api/clients.api";
import "./RendezVous.css";

const RendezVousForm = ({
  onSubmit,
  initialData,
  techniciens,
  clients,
  entretiens,
  onClientCreated
}) => {
  const [showClientForm, setShowClientForm] = useState(false);
  const [newClient, setNewClient] = useState({ nom: "", telephone: "", adresse: "" });
  const [form, setForm] = useState({
    client_id: "",
    type_entretien_id: "",
    date_rdv: "",
    heure_debut: "",
    heure_fin: "",
    etat_travaux: "EN_ATTENTE",
    techniciens_id: "",
    note: ""
  });
  const [search, setSearch] = useState("");

  // Initialisation du formulaire si modification
  useEffect(() => {
    if (initialData) {
      setForm({
        ...initialData,
        client_id: String(initialData.client_id || ""),
        type_entretien_id: String(initialData.type_entretien_id || ""),
        techniciens_id: String(initialData.techniciens_id || "")
      });
    }
  }, [initialData]);

  // Gestion des champs
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Soumission du formulaire principal
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  // Filtrage des clients pour la recherche
  const filteredClients = clients.filter((c) =>
    c.nom.toLowerCase().includes(search.toLowerCase())
  );

  // Ajouter un nouveau client depuis la modal
  const handleAddClient = async (e) => {
  e.preventDefault();
  try {
    const client = await createClient(newClient); // ne sera jamais undefined

    onClientCreated(client);
    setForm(prev => ({ ...prev, client_id: String(client.id) }));
    setShowClientForm(false);
    setNewClient({ nom: "", telephone: "" , adresse: "" });

    alert("Client ajouté avec succès !");
  } catch (error) {
    console.error(error);
    alert(error.response?.data?.message || error.message || "Erreur lors de l'ajout du client");
  }
};

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <select
            name="client_id"
            value={form.client_id}
            onChange={handleChange}
            required
          >
            <option value="">-- Sélectionner un client --</option>
            {filteredClients?.map((c) => (
              <option key={c.id} value={c.id}>
                {c.nom}
              </option>
            ))}
          </select>

          <button type="button" onClick={() => setShowClientForm(true)}>
            + Ajouter client
          </button>
        </div>

        <select
          name="type_entretien_id"
          value={form.type_entretien_id}
          onChange={handleChange}
          required
        >
          <option value="">Type entretiens</option>
          {entretiens?.map((c) => (
            <option key={c.id} value={c.id}>
              {c.nom}
            </option>
          ))}
        </select>

        <input
          type="date"
          name="date_rdv"
          value={form.date_rdv}
          onChange={handleChange}
          required
        />

        <input
          type="time"
          name="heure_debut"
          value={form.heure_debut}
          onChange={handleChange}
          required
        />

        {form.etat_travaux === "TERMINE" && (
          <input
            type="time"
            name="heure_fin"
            value={form.heure_fin || ""}
            onChange={handleChange}
          />
        )}

        <input
          type="text"
          name="note"
          value={form.note}
          onChange={handleChange}
          placeholder="Note"
        />

        <select
          name="techniciens_id"
          value={form.techniciens_id}
          onChange={handleChange}
          required
        >
          <option value="">Technicien</option>
          {techniciens?.map((c) => (
            <option key={c.id} value={c.id}>
              {c.nom}
            </option>
          ))}
        </select>

        <button type="submit">{initialData ? "Modifier" : "Ajouter"}</button>
      </form>

      {/* MODAL CLIENT */}
      {showClientForm && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Nouveau client</h3>
            <form onSubmit={handleAddClient}>
              <input
                type="text"
                placeholder="Nom"
                value={newClient.nom}
                onChange={(e) =>
                  setNewClient({ ...newClient, nom: e.target.value })
                }
                required
              />
               <input
                type="text"
                placeholder="Adresse"
                value={newClient.adresse}
                onChange={(e) =>
                  setNewClient({ ...newClient, adresse: e.target.value })
                }
                required
              />
              <input
                type="text"
                placeholder="Téléphone"
                value={newClient.telephone}
                onChange={(e) =>
                  setNewClient({ ...newClient, telephone: e.target.value })
                }
                required
              />

              <div className="modal-actions">
                <button type="submit">Enregistrer</button>
                <button
                  type="button"
                  onClick={() => setShowClientForm(false)}
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default RendezVousForm;
